import { Component, OnInit, ViewChild } from '@angular/core';
import { DateTimeComponent } from 'libs/portal/src/modules/tools/date-time/date-time.component';
import { GenericService } from 'libs/portal/src/services/generic/generic.service';
import { ToolsService } from 'libs/portal/src/services/tools/tools.service';
import { Endpoints } from '@huge-monorepo/portal/config';
import { CardTableHeader } from 'libs/portal/src/modules/tools/card-table/models/card-table-header.model';
import { CardTableOptions } from 'libs/portal/src/modules/tools/card-table/models';
import { ScreenSize } from 'libs/portal/src/layout/layout.service';
import { PaginationService } from 'libs/portal/src/services/pagination/pagination.service';
import { GenericTableHeaderOptions } from 'libs/portal/src/modules/tools/card-table/models/generic-table-header-options.model';
import { UserRightsService } from 'libs/portal/src/services/user-rights/user-rights.service';
import { Subscription } from 'rxjs';
import { ServerGroups } from '../../relay/interfaces/DashboardServer.interface';

@Component({
  selector: 'app-relay-billing-report',
  templateUrl: './relay-billing-report.component.html',
  styleUrls: ['./relay-billing-report.component.scss'],
})
export class RelayBillingReportComponent implements OnInit {
  httpObject = {};
  startDate: string;
  endDate: string;
  startDateTime: string;
  endDateTime: string;
  groups: any[] = [];
  group: string;
  resetHeader = false;
  currentPage = 0;
  serverlinkFilter = false;

  authSubscription: Subscription;
  obfuscateDetails = false;

  loading = false;
  todayT = '';
  reportResults: any[] = [];
  resetting = false;
  date = new Date();
  firstDay = '';
  displayResults = false;
  ScreenSize = ScreenSize;
  conditionalHeader: CardTableHeader[] = [];
  headerOptions: GenericTableHeaderOptions = {
    ShowSearch: false,
    DefaultDesc: true,
    DateItem: {
      Singular: false,
      Type: 'time',
      Title: 'Select ',
      StartDate: this.tools.GetStartOfMonth(new Date()).toISOString(),
      EndDate: new Date().toISOString(),
    },
    DateRequired: true,
    EnableExport: false,
    EnableSelectAll: false,
    DropDownOptions: [],
  };

  options: CardTableOptions = {
    titleProperty: 'Name',
    rowId: 'ID',
    subTitleProperty: 'data',
    additionalProperty: 'status',
    indicatorColorProperty: 'color',
    selectedProperty: 'selected',
    isSelectable: false,
    flexCardLayout: false,
    propertyRowExclusions: ['ID', 'Description'],
    stylePropertyPrefix: 'alerts',
    clickableFlexCard: false,
    textSize: 'regular',
  };

  resultsHeadersWithServerLinkFilter: CardTableHeader[] = [
    {
      ID: 'Date',
      Index: 0,
      Sort: 'Date',
      Sortable: false,
      Width: 15,
      Text: 'Date',
      Align: 'left',
    },
    {
      ID: 'Group',
      Index: 1,
      Sort: 'Group',
      Width: 15,
      Sortable: false,
      Text: 'Group',
      Align: 'left',
    },
    {
      ID: 'Server',
      Index: 2,
      Sort: 'Server',
      Width: 15,
      Sortable: false,
      Text: 'Server',
      Align: 'left',
    },
    {
      ID: 'ServerLink',
      Index: 3,
      Sort: 'ServerLink',
      Width: 15,
      Sortable: false,
      Text: 'Server Link',
      Align: 'left',
    },
    {
      ID: 'TotalSuccess',
      Index: 4,
      Sort: 'TotalSuccess',
      Width: 15,
      Sortable: false,
      Text: 'Success Total',
      Align: 'left',
    },
    {
      ID: 'TotalNull',
      Index: 5,
      Sort: 'TotalNull',
      Width: 10,
      Sortable: false,
      Text: 'Null Total',
      Align: 'left',
    },
  ];

  resultsHeadersDefault: CardTableHeader[] = [
    {
      ID: 'Date',
      Index: 0,
      Sort: 'Date',
      Sortable: false,
      Width: 30,
      Text: 'Date',
      Align: 'left',
    },
    {
      ID: 'TotalSuccess',
      Index: 4,
      Sort: 'TotalSuccess',
      Width: 30,
      Sortable: false,
      Text: 'Success Total',
      Align: 'left',
    },
    {
      ID: 'TotalNull',
      Index: 5,
      Sort: 'TotalNull',
      Width: 20,
      Sortable: false,
      Text: 'Null Total',
      Align: 'left',
    },
  ];

  constructor(
    private genericService: GenericService,
    private tools: ToolsService,
    private endpoints: Endpoints,
    private paginationService: PaginationService,
    private auth: UserRightsService,
  ) {}

  ngOnInit(): void {
    this.authSubscription = this.auth.GetUser().subscribe((user) => {
      const prev = this.obfuscateDetails;
      if (user.isObfuscated) {
        this.obfuscateDetails = true;
      } else {
        this.obfuscateDetails = false;
      }

      if (prev != this.obfuscateDetails) {
        this.groups = [];
        this.headerOptions.DropDownOptions = [];

        if (this.displayResults) {
          this.EnquireReportInfo();
        }
      }
      this.getGroups();
    });
  }

  getGroups() {
    this.startDate = this.tools.isoDateWithoutTimeZone(this.tools.GetStartOfMonth(new Date())).toISOString();
    this.endDateTime = this.tools.GetEndOfDay(this.tools.isoDateWithoutTimeZone(new Date())).toISOString();

    this.genericService.GET(this.endpoints.GET_RELAY_GROUPS).subscribe(
      (data: Object) => {
        let serverArray = data['body'];

        if (serverArray && serverArray.length > 0) {
          serverArray.forEach((element: ServerGroups) => {
            element.OriginalName = element.GroupName;
            if (this.obfuscateDetails) {
              element.GroupName = this.tools.Obfuscate(element.GroupName, 'Group ', 4);
            }
            if (element.GroupName == '') {
              element.GroupName = 'Unassigned';
            }
            this.groups.push(element);
          });
          this.headerOptions.DropDownOptions[0] = {
            Label: 'Group',
            options: this.groups,
            attribute: 'GroupName',
          };
          this.headerOptions.DropDownOptions[1] = {
            Label: 'Group by incoming link',
            options: [
              {
                Name: 'True',
                Value: true,
              },
              {
                Name: 'False',
                Value: false,
              },
            ],
            attribute: 'Name',
          };
        }
      },
      (error: any) => {
        console.log(error);
      },
    );
  }

  updateDate(newDate: string) {
    this.startDate = newDate;
  }

  updateEndDateTime(newDate: string) {
    this.endDateTime = newDate;
  }

  downloadReport() {
    this.loading = true;
    this.httpObject = {
      StartDate: this.startDate,
      EndDate: this.endDateTime,
      Group: this.group,
      GroupByIncomingLink: this.serverlinkFilter,
    };
    if (this.isValid()) {
      this.genericService.download(this.endpoints.GENERATE_RELAY_BILLING_REPORT(null, false), this.httpObject).subscribe((results) => {
        this.reportResults = results as [];
        this.loading = false;
        this.reset();
      });
    }
  }

  EnquireReportInfo() {
    this.reportResults = [];
    this.loading = true;
    this.httpObject = {
      StartDate: this.startDate,
      EndDate: this.endDateTime,
      Group: this.group,
      GroupByIncomingLink: this.serverlinkFilter,
    };
    this.genericService.POST(this.endpoints.GENERATE_RELAY_BILLING_REPORT(true, false), this.httpObject).subscribe((results) => {
      let tempReportResults = results['body'] as [];
      if (tempReportResults && tempReportResults.length > 0) {
        tempReportResults.forEach((element: any) => {
          if (this.serverlinkFilter) {
            this.reportResults.push({
              Date: element.Date,
              Group: this.obfuscateDetails && element.Group?.length > 0 ? this.tools.Obfuscate(element.Group, 'Group ', 4) : element.Group,
              Server: this.obfuscateDetails && element.Server?.length > 0 ? this.tools.Obfuscate(element.Server, 'Server ', 4) : element.Server,
              ServerLink: this.obfuscateDetails && element.ServerLink?.length > 0 ? this.tools.Obfuscate(element.ServerLink, 'ServerLink ', 4) : element.ServerLink,
              TotalSuccess: element.TotalSuccess,
              TotalNull: element.TotalNull,
            });
            this.conditionalHeader = this.resultsHeadersWithServerLinkFilter;
          } else {
            this.reportResults.push({
              Date: element.Date,
              TotalSuccess: element.TotalSuccess,
              TotalNull: element.TotalNull,
            });

            this.conditionalHeader = this.resultsHeadersDefault;
          }
        });
        this.reportResults.forEach((element: any) => {
          Object.keys(element).forEach(function (key) {
            if (element[key] === null) {
              element[key] = '-';
            }
          });
        });
      }
      this.displayResults = true;
      this.loading = false;
    });
  }

  getFirstDayOfMonth(year, month) {
    const date = new Date(year, month, 1, 2, 0);
    return date.toISOString();
  }

  reset() {
    this.reportResults = [];
    this.resetHeader = true;
    this.headerOptions.EnableView = false;
    this.headerOptions.EnableClear = false;
    this.headerOptions.EnableExport = false;
    this.startDate = this.firstDay;
    this.endDateTime = this.tools.GetEndOfDay(new Date()).toISOString();
    this.displayResults = false;
    this.serverlinkFilter = false;
    this.group = '';

    setTimeout(() => {
      this.resetHeader = false;
    });
  }

  isValid(): Boolean {
    return true;
  }

  groupSelect(event: any) {
    console.log(event);

    if (event.Label == 'Group') {
      this.group = event.Value.OriginalName;
      this.headerOptions.EnableView = true;
      this.headerOptions.EnableClear = true;
      this.headerOptions.EnableExport = true;
    } else {
      this.serverlinkFilter = event.Value.Value;
    }
  }

  setToggle() {
    this.serverlinkFilter = !this.serverlinkFilter;
  }

  onPageChange(event: any) {
    this.currentPage = event;
    const startIndex = (this.currentPage - 1) * 10;
    let endIndex = startIndex + 10;
    if (endIndex > this.reportResults.length) {
      endIndex = this.reportResults.length;
    }
    setTimeout(() => {
      this.paginationService.emit();
    });
  }

  setStart(event: any) {
    console.log(event);
    this.startDate = event;
  }

  setEnd(event: any) {
    console.log(event);
    this.endDateTime = event;
  }
}
